import React, { useState } from "react";
import "./modal.css";
import { toast } from 'react-toastify';
import axios from 'axios';
import { useEffect } from "react";
import DataLoader from "../Loader/DataLoader";
import MaskedInput from "react-text-mask";
import downloadBrochure from "../../Investment/Images/Icon-feather-download.svg";

const FundAllocationModal = ({ show, onClose, InsurerId, handleSubmit, selectedFunds }) => {

    const [periodList, setPeriodList] = useState([{ id: "sinceinception", name: "Since Inception" }, { id: "3 Years", name: "3 Years" }, { id: "5 Years", name: "5 Years" }]);
    const [selectedPeriod, setSelectedPeriod] = useState('sinceinception');
    const [loader, setLoader] = useState(false);
    const [allocations, setAllocations] = useState([]);
    const [allFundList, setAllFundList] = useState([]);

 /*   const handleAllocationChange = (ind, e) => {
        const { name, value } = e.target;
  
        if ( value <= 100) {
            const copyAllocation = [...allocations];
            copyAllocation[ind][name] = value;
            const total = copyAllocation.reduce((acc, elem) => {
                const fund = parseInt(elem.percent) || 0;
                return acc + fund;
            }, 0);
            if (total <= 100) {
            setAllocations(copyAllocation);
            }else {
                toast.error("Value should not be greater than 100");
            }
        } 
    };
*/

    const handleAllocationChange = (ind, e) => {
        const { name, value } = e.target;
        const val = parseInt(value || "0", 10);

        // Make a shallow copy
        const copyAllocation = [...allocations];

        // Temporarily update the new value
        copyAllocation[ind][name] = val;

        // Calculate total
        const total = copyAllocation.reduce((acc, elem) => {
            const fund = parseInt(elem.percent) || 0;
            return acc + fund;
        }, 0);

        if (val > 100) {
            toast.error("Value should not be greater than 100");
            copyAllocation[ind][name] = ""; // reset to empty (or "0" if you prefer)
            setAllocations(copyAllocation);
            return;
        }

        if (total > 100) {
            // ❌ Remove (reset) the entered value if total exceeds 100
            toast.error("Value should not be greater than 100");
            copyAllocation[ind][name] = ""; // reset to empty (or "0" if you prefer)
            setAllocations(copyAllocation);
            return;
        }

        // ✅ Otherwise accept the input
        setAllocations(copyAllocation);
    };


    const total = allocations?.reduce((acc, elem) => {
        const value = parseInt(elem.percent) || 0;
        return acc + value;
    }, 0);

    const getFundList = () => {
        setAllocations([]);
        setLoader(true);
        const Req = {
            ViewOurFundReturnsYear: selectedPeriod,
            InsurerId: InsurerId
        }
        const model = {
            URL: "GetFundAllocationList",
            Req
        }

        axios.post(`central/centralcall/callreqwithheader`, model).then(res => {
           
            setAllocations(res.data.Data || []);
            setAllFundList(res.data.Data || []);
            setLoader(false);

        }).catch(error => {
            console.log({ error });
            toast.error(error.message);
            setLoader(false);
        })
    }

    useEffect(() => {
        if (selectedFunds.length && allFundList.length) {
            const updatedFund = allFundList.map((item) => {
                const matched = selectedFunds.find(row => row.code == item.FundCode);
                return matched ? { ...item, FundCode: matched.code, percent: matched.percent } : item;
            });

            const sortedFund = updatedFund.sort((a, b) => (b.percent || 0) - (a.percent || 0));

            setAllocations(sortedFund);
        }
    }, [selectedFunds, allFundList]);

    useEffect(() => {
        getFundList();
    }, [selectedPeriod]);

    const onSubmit = () => {
        if (total == 100) {
            onClose();
            handleSubmit(allocations);
        } else {
            toast.error('Total fund amount should be 100%');
        }
    }

    return (
        <div className="fundAllocation">

            {/* Header */}
            <div className="modal-header">
                <h2>Fund Allocation details</h2>
                <button className="close-btn" onClick={onClose}>×</button>
            </div>
            <div className="modal-body">
                {/* Info */}
                <p className="modal-info">
                    Get upto <strong>12 free switches</strong><br />
                    Avail benefits of low fund management charges
                </p>

                {/* Period buttons */}
                <div className="period-buttons">
                    {periodList?.map((p) => (
                        <button
                            key={p}
                            className={`period-btn ${selectedPeriod === p.id ? "active" : ""}`}
                            onClick={() => setSelectedPeriod(p.id)}
                        >
                            {p.name}
                        </button>
                    ))}
                </div>

                {/* Fund list */}
                <div className="fund-list">
                    {loader ? <DataLoader />
                        :
                        allocations.length >0  ?

                    allocations.map((item, ind) => (
                        <div className="fund-item">
                        <div className="fundCodeName">
                                <strong>{item.Name}</strong>
                                <div className="d-flex fundDetails">
                                    <div className="mx-2 separationPart">
                                        <p className="return">Return: {item.Returns} %</p>
                                        <p className="return">Fund Size: {item.FundSize}</p>
                                        <p className="return">NAV: {item.NAV}</p>
                                    </div>
                                    <div>
                                        {item?.InceptionDate && <p className="return">Inception Date: {item.InceptionDate}</p>}
                                        <p className="return">
                                            <a href={item?.FundPdfUrl} target="_blank" className="return" >
                                                <span className="">Download: </span>
                                                <img src={downloadBrochure} className="IconPic" />
                                            </a>
                                        </p>
                                        
                                    </div>
                                </div>

                                

                            </div>
                           

                            <MaskedInput
                                className="fundCodeInp"
                                type="tel"
                                mask={[/\d/, /\d/, /\d/]}
                                guide={false}
                                showMask={false}
                                name="percent"
                                value={item.percent}
                                onChange={(e) => handleAllocationChange(ind, e)}
                            />
                        </div>))
                        

                        : <div className="fund-item">Data Not Found</div>}
                </div>

                {/* Total */}
                <div className="total">Total: {total}%</div>
            </div>
            {/* Footer */}
            <div className="modal-footer">
                <button className="save-btn" onClick={onSubmit}>Save changes</button>
            </div>
        </div>

    );
};

export default FundAllocationModal;
